export default "__VITE_ASSET__DsMnCMme__"